// extracted by mini-css-extract-plugin
export default {"container":"QuizIntro_container__pHe5l"};